import React, { Component } from "react";
import "./InfoBox.css";

class InfoBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      label: this.props.label,
      score: this.props.score,
      current_score: this.props.current_score,
      header: this.props.header,
      /* [AW20200106] This adjustment was made at the request of Allison Smith to resolve a decimal issue in the calculator.  */
      outofnum: Math.round(this.props.outofnum * 100, 0) / 100,
      outofden: this.props.outofden,
      backgroundColor: this.props.color1
    };
  }

  colorChange() {
    const currentValue = this.state.current_score;
    const newValue = this.state.score;

    let newColor = this.props.color1;
    if (newValue >= 0 && newValue <= 25 && newValue !== currentValue) {
      newColor = "infobox actual_intervene";
    }
    if (newValue >= 25 && newValue < 50 && newValue !== currentValue) {
      newColor = "infobox actual_watch";
    }
    if (newValue >= 50 && newValue < 75 && newValue !== currentValue) {
      newColor = "infobox actual_reinforce";
    }
    if (newValue >= 75 && newValue <= 100 && newValue !== currentValue) {
      newColor = "infobox actual_model";
    }
    if (newValue >= 0 && newValue < 25 && newValue === currentValue) {
      newColor = "infobox intervene";
    }
    if (newValue >= 25 && newValue < 50 && newValue === currentValue) {
      newColor = "infobox watch";
    }
    if (newValue >= 50 && newValue < 75 && newValue === currentValue) {
      newColor = "infobox reinforce";
    }
    if (newValue >= 75 && newValue <= 100 && newValue === currentValue) {
      newColor = "infobox model";
    }
    return newColor;
  }

  render() {
    return (
      <div>
        <h3 className="infoBoxHeader">{this.props.header}</h3>
        <div className={this.colorChange()}>
          <div className="label">{this.state.label}</div>
          <div className="score">{this.state.score}</div>
          <div className="outof">
            {/* <nobr> */}
            {this.state.outofnum} out of
            <br />
            {this.state.outofden}
            {/* </nobr> */}
          </div>
        </div>
      </div>
    );
  }
}

export default InfoBox;
